
'use strict';

var $ = require('jquery'),
  config = require('../../js/config'),
  WIDTH_BUFFER = 20,
  mediator = require('mediatorjs'),
  Backbone = require('backbone');

Backbone.$ = $;

var OfficeTertiaryScrollerView = Backbone.View.extend({

  events: {
    'click .Region-item-tertiary-selector-inner a': 'showSubRegion'
  },

  initialize: function() {
    this.$innerRegion = this.$('.Region-item-tertiary-selector-inner');
    this.$triggerLinks = this.$innerRegion.find('a');
    this.setTertiaryScollerWidth();
  },

  showSubRegion: function(e) {
    var $target = $(e.currentTarget);
    e.preventDefault();
    this.$triggerLinks.removeClass(config.classes.isActive);
    $target.addClass(config.classes.isActive);
    mediator.trigger(config.events.offices.showSubRegion, $target.data('targetLocation').toLowerCase());
  },

  reset: function() {
    this.$triggerLinks.first().trigger('click');
  },

  setTertiaryScollerWidth: function() {
    var totWidth = 0;
    this.$triggerLinks.each(function() {
      totWidth += $(this).outerWidth();
    });
    this.$innerRegion.css({width: totWidth + WIDTH_BUFFER});
  }
});

module.exports = OfficeTertiaryScrollerView;



// WEBPACK FOOTER //
// ./assets/components/Offices/OfficeTertiaryScrollerView.js